import { NgModule, Optional, SkipSelf } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { VoucherEffects } from './voucher.effects';
import { IVoucherFeature } from './voucher.feature.state';
import { VoucherReducer } from './voucher.reducer';
import { nameof } from '@symphony-solo/shared/utils/src';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<IVoucherFeature>('VoucherFeature'), VoucherReducer),
    EffectsModule.forFeature([VoucherEffects]),
  ],
})
export class VoucherStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: VoucherStateModule
  ) {
    if (parentModule) {
      throw new Error('VoucherStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
